import React from 'react';
import { FolderKanban, Rocket } from 'lucide-react';

import ProjectActions from './ProjectActions';
import { Badge } from '@/Modules/Core/Components/shadcn/badge';
import { cn } from '@/lib/utils';

const ProjectsGrid = ({
  projects,
  onOpenRollouts,
  onCreateRollout,
  onCreateAccumulative,
  canCreateRollout = true,
  canOpenRollouts = true,
}) => (
  <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
    {projects.map((project) => (
      <article
        key={project.key}
        className={cn(
          'group flex h-full min-h-[296px] w-full flex-col rounded-xl border border-border/40 bg-card/30 p-5 transition-all duration-200',
          canOpenRollouts
            ? 'cursor-pointer hover:-translate-y-0.5 hover:border-border/70 hover:bg-card/50'
            : 'cursor-default'
        )}
        onClick={() => {
          if (canOpenRollouts) {
            onOpenRollouts(project);
          }
        }}
      >
        <div className="flex items-start gap-3">
          <div className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
            <FolderKanban className="h-4 w-4" />
          </div>

          <div className="min-w-0 space-y-2">
            <div className="flex flex-wrap items-center gap-2">
              <h3 className="truncate text-[17px] font-semibold tracking-[-0.01em] text-foreground">
                {project.projectName}
              </h3>
              <Badge className="rounded-xl border px-2 py-0.5 text-[10px] font-medium leading-4">
                {project.versionName}
              </Badge>
            </div>

            <p className="pr-1 text-[12px] leading-5 text-muted-foreground">
              {project.description}
            </p>
          </div>
        </div>

        <div className="flex flex-1 flex-col justify-center py-6 text-center">
          <p className="text-[11px] font-medium uppercase tracking-[0.18em] text-muted-foreground">
            Rollouts
          </p>
          <div className="mt-3 flex items-center justify-center gap-2 text-primary">
            <span className="text-[32px] font-semibold leading-none text-foreground">
              {project.rolloutCount}
            </span>
          </div>
          <p className="mt-2 text-[12px] leading-5 text-muted-foreground">
            Generated rollout packages for this version
          </p>
        </div>

        <div className="mt-auto border-t border-border/35 pt-4">
          <ProjectActions
            project={project}
            onCreateRollout={onCreateRollout}
            onCreateAccumulative={onCreateAccumulative}
            canCreateRollout={canCreateRollout}
          />
        </div>
      </article>
    ))}
  </div>
);

export default ProjectsGrid;
